module.exports = __webpack_public_path__ + "63f7b112500b7e2ea3ff8eb8acd25785.svg";